<template>
    <section class="main-support primary darken-1">
        <v-container>
            <v-sheet color="transparent" class="main-support__form">
                <v-row justify="end">
                    <v-col cols="12" lg="2">
                        <v-select v-model="donus.period" block flat solo hide-details :items="periods" />
                    </v-col>
                    <v-col cols="12" lg="8">
                        <div class="amounts-wrap">
                            <v-btn-toggle v-model="donus.amount" mandatory @change="amount = null">
                                <v-btn v-for="amount in amounts" :key="amount" :value="amount">
                                    <span>{{ amount?.format?.() }}원</span>
                                </v-btn>
                                <v-btn @click="focusTextField">
                                    <v-text-field v-model="amount" ref="customAmountField" type="number" suffix="원" solo flat hide-details hide-spin-buttons @input="value => amount = value.replace(/[^0-9]/g,'')" />
                                </v-btn>
                            </v-btn-toggle>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="2">
                        <v-btn block color="primary" rounded="pill" large class="support-button" @click="submit()">
                            후원하기
                            <v-icon>mdi-cursor-default-click-outline</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-sheet>
        </v-container>
        <v-sheet color="grey lighten-5" class="main-support__text">
            <v-container>
                <p class="font-size-14 font-size-md-20 word-keep-all font-weight-medium text-center">
                    <v-row justify="center" class="row--x-small">
                        <v-col cols="auto"> <v-img src="/images/icon/icon-gift.svg" class="icon-gift" /> </v-col>
                        <v-col cols="" md="auto">월 <strong class="primary--text">10,000</strong>원이면, 전 세계 어린이를 위해 책가방 <strong class="primary--text">50개</strong>를 지원할 수 있습니다.</v-col>
                    </v-row>
                </p>
            </v-container>
        </v-sheet>
    </section>
</template>

<script>
export default {
    data() {
        return {
            amount: null,
            donus: {
                period: "pledge",
                amount: 10000
            },

            amounts: [10000, 30000, 50000],
            periods: [
                { text: "정기", value: "pledge" },
                { text: "일시", value: "oneoff" }
            ]
        };
    },
    methods: {
        focusTextField() {
            this.$nextTick(() => {
                if (this.$refs.customAmountField) {
                    this.$refs.customAmountField.focus();
                }
            });
        },
        validate(){
            try{
                if(this.amount) this.donus.amount = this.amount;
                if(this.donus.amount < 10000) throw new Error("10,000원 이상 후원하기가 가능합니다");

                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },
        submit(){
            if(this.validate()){
                window.open(`https://secure.donus.org/withcan/pay/step1?period=${this.donus.period}&price=${this.donus.amount}`);
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.main-support {
    &__form {
        min-height: 130px;
        padding: 20px 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    &__text {
        padding: 12px 0;
        .icon-gift {
            width: 16px;
        }
    }
    .v-select {
        ::v-deep(.v-select__selection) {
            width: 100%;
            margin-right: 0;
            font-size: 18px;
        }
        ::v-deep(.v-input__control) {
            .v-input__slot {
                padding: 0 26px;
            }
        }
        ::v-deep(input) {
            text-align: center;
        }
    }
    .v-input {
        border-radius: 999px;
    }
    .amounts-wrap {
        margin: -2px;
        .v-btn-toggle {
            background-color: transparent;
            width: 100%;
            flex-wrap: wrap;
            justify-content: center;
            > .v-btn {
                background-color: transparent !important;
                border: none;
                flex-basis: calc(100% / 3);
                padding: 2px;
                opacity: 1;
                &:last-child {
                    cursor: text;
                    flex-basis: 100%;
                }
                &::before {
                    display: none;
                }
                ::v-deep(.v-btn__content) {
                    display: block;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    border: 2px solid #fff;
                    border-radius: 999px;
                    max-width: 100%;
                    color: #fff;
                    font-size: 16px;
                    font-weight: 700;
                }
                .v-input {
                    height: 100%;
                    &::before {
                        content: "금액 직접 입력";
                        position: absolute;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 100%;
                        color: #fff;
                        z-index: 1;
                    }
                    ::v-deep {
                        .v-input__control,
                        .v-input__slot {
                            height: 100%;
                            background-color: transparent;
                            color: var(--v-primary-darken1);
                        }
                    }
                    ::v-deep(input) {
                        text-align: center;
                        font-size: 20px;
                        color: var(--v-primary-darken1);
                        &::-webkit-inner-spin-button {
                            -webkit-appearance: none;
                        }
                    }
                }
                &--active {
                    ::v-deep(.v-btn__content) {
                        background-color: #fff;
                        color: var(--v-primary-base);
                    }
                    .v-input {
                        &::before {
                            display: none;
                        }
                    }
                }
            }
        }
    }
    .support-button {
        font-size: 20px;
        box-shadow: 0 4px 33.8px 0 rgba(0, 0, 0, 0.25);
        .v-icon {
            font-size: 20px;
            margin-left: 10px;
        }
    }
}
@media (min-width: 1024px) {
    .main-support {
        &__text {
            .icon-gift {
                width: 24px;
            }
        }
        .v-select {
            width: 140px;
        }
        .v-input {
            border-radius: 999px;
        }
        .amounts-wrap {
            margin: 0 -6px;
            .v-btn-toggle {
                > .v-btn {
                    padding: 0 6px;
                    flex-basis: 25%;
                    ::v-deep(.v-btn__content) {
                        height: 48px;
                    }
                    &:last-child {
                        flex-basis: 25%;
                    }
                    ::v-deep(.v-btn__content) {
                        font-size: 20px;
                    }
                }
            }
        }
    }
}
</style>